// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2TJbO","range":"MonthRangeSwitch_range__1eR_v","disabled":"MonthRangeSwitch_disabled__2oItO"};